<template>
	<div>
        <!-- 海外文章页-作者卡片 -->
        <AuthorCard v-if="isAbroad"/>
        <template v-if="articleGrade<2">
            <!-- 搜索框 -->
            <Search v-if="showSearch"/>
            <!-- 独立广告位 -->
            <template v-if="isGradeA">
                <!-- 右侧冠名 -->
                <div class="godA" id="nav_button" data-spm="ad-right-sponsor"></div>
                <!-- 第一矩形 -->
                <div class="godR" id="god_1" data-spm="ad-sq1" :style="getGod1Style"></div>
                <div id="god_1_2" :style="getGod1_2Style" data-spm="ad-sq1"></div>
            </template>

            <!--  热门精选 -->
            <HotGallery v-if="showHotGallery"/>
            <!-- 独立广告位 -->
            <template v-if="isGradeA">
                <div v-if="isAbroad" id="jingxuan-taboola" data-spm="jingxuan-taboola" style="width: 300px; margin: 0 auto;"></div>
                <div class="godR" id="god_2" data-spm="ad-sq2" style="display:block"></div>
                <div id="god_2_2" style="padding:10px 20px; display: none;" data-spm="ad-sq2"></div>
            </template>

            <!-- 24小时热文+吸顶样式-->
            <div :class="[needSticky&&'right-fixed']" >
                <Hot24News />
                <!-- 吸顶广告-->
                <div v-show="isGradeA && needSticky">
                    <div class="godR" id="god_fix_1" data-spm="ad-sq6" style="display: block;"></div>
                    <div id="god_6_2" class="god-ad-fix" style="display: none; overflow: hidden;" data-spm="ad-sq6"> </div>
                </div>
            </div>
            <!-- 独立广告位 -->
            <template v-if="isGradeA">
                <div class="godR" id="god_3" data-spm="ad-sq3" style="display:block"></div>
                <div id="god_3_2" style="padding:10px 20px; display: none;" data-spm="ad-sq3"></div>
            </template>

            <!-- 搜狐号 -->
            <RecommendWriter/>
            <!-- 独立广告位 -->
            <template v-if="isGradeA">
                <div class="godR" id="god_4" data-spm="ad-sq4" style="display:block"> </div>
                <div id="god_4_2" style="padding:10px 20px; display: none;" data-spm="ad-sq4"></div>
                <div id="god_5" style="padding:10px 20px;" data-spm="sqfive-ad"></div>
            </template>
        </template>
    </div>
</template>

<script>
import Search from './Search.vue'
import AuthorCard from './AuthorCard.vue'
import HotGallery from './HotGallery.vue'
import Hot24News from './Hot24News.vue'
import RecommendWriter from './RecommendWriter.vue'
import Util from '../../_utils/util.js';
export default{
    name: 'rightSideBar',
    props: {
        type: {
            default: 'normal', // abroad-海外文章页 normal-常规文章页
            type: String
        }
    },
    components: {
        Search,
        HotGallery,
        Hot24News,
        RecommendWriter,
        AuthorCard,
    },
    data(){
        return {
            articleGrade: window.pcArticleInfo.sGrade, // 文章等级
            observer: null,
            targetNode: null,
            needSticky: false, // 吸顶24小时热文
            config: {
                childList: true, // 监听子节点变化
                subtree: true // 监听后代节点变化
            }
        }
    },
    mounted() {
        this.targetNode = document.getElementById("right-side-bar")
        this.initObserver()
        window.addEventListener('scroll',this.throttleObserveScroll())
    },
    computed: {
        isGradeA() {
            return this.articleGrade == 0
        },
        // 海外文章页
        isAbroad() {
            return this.type === 'abroad'
        },
        showSearch() {
            return !this.isAbroad
        },
        showHotGallery() {
            return !this.isAbroad
        },
        getGod1Style() {
            if(this.isAbroad)return 'padding:10px 20px;display: none;'
            return 'display: block'
        },
        getGod1_2Style() {
            if(this.isAbroad)return 'padding:10px 20px;'
            return 'padding:10px 20px; display: none;'
        }
    },
    methods: {
        initObserver() {
            if(!window.MutationObserver)return
            // dom观察器
            this.observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    this.observeRightSideToTop()
                });
            });
            this.observer.observe(this.targetNode, this.config);
        },

        // 右边栏距离视口的距离
        getRightSideToTop() {
            return this.targetNode?.getBoundingClientRect()?.bottom || ''
        },
        // 节流
        throttleObserveScroll() {
            return Util.throttle(this.observeRightSideToTop,200)
        },

        // 滚动监听
        observeRightSideToTop() {
            const toTop = this.getRightSideToTop()
            this.needSticky = toTop <= 0 ? true : false
        }
    },
    destroyed() {
        window.removeEventListener('scroll',this.throttleObserveScroll()) // 停止绑定
        if(this.observer)this.observer?.disconnect() // 停止观察
    },
}
</script>

<style lang="less">
.right-fixed {
    width: 340px;
    top: 0;
    position: fixed;
    transform: translateZ(0);
}

.tag-index, .article-page, .channel-index, .channel-sub {
  .right-fixed {
	width: 340px;
    top: 60px;
    position: fixed;
    transform: translateZ(0);
  }
}

</style>
